// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .editor-container {
  height: 100% !important;
}

:host {
  position: relative;
}

.floating-toolbar {
  display: none;
  position: absolute;
  top: 6px;
  right: 12px;
  z-index: 10;
  align-items: center;
  gap: 2px;
  background: var(--preset-card, #1e1e1e);
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 4px;
  padding: 2px;
  opacity: 0.7;
  transition: opacity 0.15s;
}
:host-context(.dockview-panel-host) .floating-toolbar {
  display: flex;
}
.floating-toolbar:hover {
  opacity: 1;
}
.floating-toolbar button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--preset-foreground, #93a1a1);
  cursor: pointer;
  border-radius: 3px;
}
.floating-toolbar button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.floating-toolbar button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.external-change-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  background: var(--tertiary-container, #ffd8a8);
  color: var(--on-tertiary-container, #422b00);
  font-size: 13px;
  border-bottom: 1px solid var(--outline-variant);
}
.external-change-notice span {
  flex: 1;
}
.external-change-notice button {
  min-width: auto;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/monaco-widget/monaco-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,uCAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AADJ;AAGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AADN;AAII;EACE,oCAAA;AAFN;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,8CAAA;EACA,4CAAA;EACA,eAAA;EACA,+CAAA;AAJF;AAME;EACE,OAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AALJ","sourcesContent":["::ng-deep .editor-container {\n  height: 100% !important;\n}\n\n:host {\n  position: relative;\n}\n\n.floating-toolbar {\n  display: none;\n  position: absolute;\n  top: 6px;\n  right: 12px;\n  z-index: 10;\n  align-items: center;\n  gap: 2px;\n  background: var(--preset-card, #1e1e1e);\n  border: 1px solid rgba(128, 128, 128, 0.25);\n  border-radius: 4px;\n  padding: 2px;\n  opacity: 0.7;\n  transition: opacity 0.15s;\n\n  :host-context(.dockview-panel-host) & {\n    display: flex;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--preset-foreground, #93a1a1);\n    cursor: pointer;\n    border-radius: 3px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n}\n\n.external-change-notice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  background: var(--tertiary-container, #ffd8a8);\n  color: var(--on-tertiary-container, #422b00);\n  font-size: 13px;\n  border-bottom: 1px solid var(--outline-variant);\n\n  span {\n    flex: 1;\n  }\n\n  button {\n    min-width: auto;\n    padding: 2px 8px;\n    font-size: 12px;\n    line-height: 1.4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
